/* tslint:disable */
/* eslint-disable */
/**
 * FastAPI
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: 0.1.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
/**
 * 
 * @export
 * @interface WifiClientChangePayload
 */
export interface WifiClientChangePayload {
    [key: string]: any | any;
    /**
     * 
     */
    type: WifiClientChangePayloadTypeEnum;
    /**
     * 
     */
    connected: boolean;
    /**
     * 
     */
    mac: string;
    /**
     * 
     */
    ipv4?: string | null;
}


/**
 * @export
 */
export const WifiClientChangePayloadTypeEnum = {
    WifiClientChange: 'wifi_client_change',
} as const;
export type WifiClientChangePayloadTypeEnum = typeof WifiClientChangePayloadTypeEnum[keyof typeof WifiClientChangePayloadTypeEnum];


/**
 * Check if a given object implements the WifiClientChangePayload interface.
 */
export function instanceOfWifiClientChangePayload(value: object): value is WifiClientChangePayload {
    if (!('type' in value) || value['type'] === undefined) return false;
    if (value['type'] !== 'wifi_client_change') return false;
    
    if (!('connected' in value) || value['connected'] === undefined) return false;
    if (!('mac' in value) || value['mac'] === undefined) return false;
    return true;
}

export function WifiClientChangePayloadFromJSON(json: any): WifiClientChangePayload {
    return WifiClientChangePayloadFromJSONTyped(json, false);
}

export function WifiClientChangePayloadFromJSONTyped(json: any, ignoreDiscriminator: boolean): WifiClientChangePayload {
    if (json == null) {
        return json;
    }
    return {
        
            ...json,
        'type': json['type'],
        'connected': json['connected'],
        'mac': json['mac'],
        'ipv4': json['ipv4'] === undefined ? undefined : json['ipv4'] === null ? null : json['ipv4'],
    };
}

export function WifiClientChangePayloadToJSON(json: any): WifiClientChangePayload {
    return WifiClientChangePayloadToJSONTyped(json, false);
}

export function WifiClientChangePayloadToJSONTyped(value?: WifiClientChangePayload | null, ignoreDiscriminator: boolean = false): any {
    if (value == null) {
        return value;
    }

    return {
        
            ...value,
        'type': value['type'],
        'connected': value['connected'],
        'mac': value['mac'],
        'ipv4': value['ipv4'],
    };
}

